import { useEffect, useState } from "react";
import ReturnPolicyTable from "./ReturnPolicyTable";
import EditReturnPolicyModal from "./EditReturnPolicyModal";
import { getPolicy, updatePolicy } from "./PolicyApi";
import { toast } from "react-toastify";

// Define a type for local state
type LocalPolicyType = {
  returnDays: number;
  exchangeDays: number;
  buybackAfter: number;
};

const ReturnPolicySection = () => {
  const [showModal, setShowModal] = useState(false);
  const [policyData, setPolicyData] = useState<LocalPolicyType>({
    returnDays: 0,
    exchangeDays: 0,
    buybackAfter: 0,
  });

  useEffect(() => {
    loadPolicy();
  }, []);

  const loadPolicy = async () => {
    try {
      const res = await getPolicy();

      const data = res;

      const mappedPolicy: LocalPolicyType = {
        returnDays: data.returnDays,
        exchangeDays: data.exchangeDays,
        buybackAfter: data.buyBackDays,
      };

      setPolicyData(mappedPolicy);
    } catch (error) {
      console.error("❌ Failed to load policy", error);
    }
  };


  const handleEditClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSave = async (updatedPolicy: LocalPolicyType) => {
    try {
      const payload = {
        returnDays: updatedPolicy.returnDays,
        exchangeDays: updatedPolicy.exchangeDays,
        buyBackDays: updatedPolicy.buybackAfter,
      };



      // await updatePolicy(payload);
      const res = await updatePolicy(payload);
      toast.success(res?.message || "Policy updated successfully.");
      setPolicyData(updatedPolicy);
      setShowModal(false);
    } catch (error) {
      toast.error(
        "Failed to update policy. Try again."
      );
      console.error("❌ Failed to update policy", error);
    }
  };

  return (
    <>
      <div className="page-content">
        <ReturnPolicyTable policyData={policyData} onEdit={handleEditClick} />

        <EditReturnPolicyModal
          show={showModal}
          handleClose={handleCloseModal}
          policyData={policyData}
          onSave={handleSave}
        />
      </div>
    </>
  );
};

export default ReturnPolicySection;
